<template>
  <div
    class="notice-new-arrivals-modal-section"
    :class="{ 'notice-new-arrivals-modal-section--is-pc': isPc }"
  >
    <div class="notice-new-arrivals-modal-section__modal">
      <p class="notice-new-arrivals-modal-section__new">{{ $tc('common.new') }}</p>
      <h3 class="notice-new-arrivals-modal-section__title">
        {{ $tc('HomePage.newArrivalsModal.title') }}
      </h3>
      <p
        class="notice-new-arrivals-modal-section__message"
        v-html="$tc('HomePage.newArrivalsModal.message')"
      />
      <p v-if="externalLink" class="notice-new-arrivals-modal-section__detail">
        <atom-link
          class="notice-new-arrivals-modal-section__detail-link"
          :url="externalLink"
          :linkText="$tc('HomePage.newArrivalsModal.detailLinkLabel')"
          :imgPath="require('@/assets/img/icon/icon_external_link_gray75.svg')"
          :iconPosition="'right'"
        />
      </p>
      <p
        v-if="pageLink"
        class="notice-new-arrivals-modal-section__mission"
        @click="handleOkClicked(true)"
      >
        <atom-router-button
          class="notice-new-arrivals-modal-section__mission-button"
          to=""
          :linkText="$tc('HomePage.newArrivalsModal.missionButtonLabel')"
        />
      </p>
      <button
        class="notice-new-arrivals-modal-section__button notice-new-arrivals-modal-section__button--light--secondary"
        :class="{ 'notice-new-arrivals-modal-section__button--no-page-link': !pageLink }"
        @click="handleOkClicked(false)"
      >
        {{ $tc('common.ok') }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import DeviceInfo from '@/util/DeviceInfo'
import AtomLink from '@/components/atoms/AtomLink.vue'
import AtomRouterButton from '@/components/atoms/AtomRouterButton.vue'

/**
 * 機能アップデートのお知らせモーダル セクション
 */
export default defineComponent({
  name: 'NoticeNewArrivalsModalSection',
  components: {
    AtomRouterButton,
    AtomLink,
  },
  props: {
    /**
     * 外部リンク
     */
    externalLink: {
      type: String,
      default: '',
    },
    /**
     * ページ内リンク
     */
    pageLink: {
      type: String,
      default: '',
    },
  },
  setup(_, { emit }) {
    const isPc = DeviceInfo.isForPC()
    const handleOkClicked = (pageTransition: boolean) => {
      emit('onClickOk', pageTransition)
    }

    return {
      isPc,
      handleOkClicked,
    }
  },
})
</script>

<style scoped lang="scss">
.notice-new-arrivals-modal-section {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  display: flex;
  text-align: center;
  background-color: $black70;

  &__new {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 24px;
    font-size: 12px;
    font-weight: bold;
    color: $black;
    letter-spacing: 0.04em;
    background-color: $green-light;
    border-radius: 80px;
  }

  &__modal {
    width: 100%;
    max-width: 343px;
    padding: 20px 16px;
    margin: auto;
    background-color: rgba(#fff, 0.9);
    border-radius: 12px;
  }

  &__title {
    margin-top: 11px;
    font-size: 16px;
    font-weight: 500;
    color: $black;
    white-space: pre-wrap;
  }

  &__message {
    margin-top: 20px;
    font-size: 12px;
    font-weight: 500;
    color: $gray75;
    letter-spacing: 0.02em;
    white-space: pre-wrap;
    text-align: left;
  }

  &__detail {
    margin-top: 1em;
    text-align: left;

    &-link {
      font-weight: 500;
      color: $gray75;
      text-decoration: none;
      border-bottom: 1px solid $gray75;

      &::v-deep {
        i {
          display: inline-block;
          height: 12px;
          transform: translateY(-2px);

          img {
            width: 12px;
          }
        }
      }
    }
  }

  &__mission {
    margin-top: 20px;
  }

  &__button {
    margin-top: 8px;
    @include button();

    width: 100%;
    height: 40px;

    &--no-page-link {
      margin-top: 20px;
    }
  }
}
</style>

<style lang="scss">
.notice-new-arrivals-modal-section {
  &__message {
    ul {
      margin-top: 8px;

      li {
        position: relative;
        padding-left: 10px;

        &:not(:last-of-type) {
          margin-bottom: 8px;
        }

        &::before {
          content: '';
          position: absolute;
          top: 5px;
          left: 0;
          width: 8px;
          height: 8px;
          background-color: $gray75;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
